import * as yup from 'yup';

import * as ERRORS from '../../constants/errors';
import { PHONE_REGEX } from '../../utils/regex';

export const editComplexSchema = yup.object().shape({
  complexName: yup
    .string()
    .min(3, ERRORS.NAME_IS_SHORT)
    .required(ERRORS.NAME_IS_REQUIRED),
  country: yup.string().required(ERRORS.COUNTRY_IS_REQUIRED),
  city: yup.string().required(ERRORS.CITY_IS_REQUIRED),
  complexAddress: yup.string().required(ERRORS.ADDRESS_IS_REQUIRED),
  district: yup.string().optional(),
  phone: yup
    .string()
    .matches(PHONE_REGEX, {
      message: ERRORS.PHONE_IS_INVALID,
      excludeEmptyString: true,
    })
    .min(5, ERRORS.PHONE_IS_INVALID)
    .max(15, ERRORS.PHONE_IS_INVALID)
    .required(ERRORS.PHONE_IS_REQUIRED),
  description: yup.string().max(1000, ERRORS.DESCRIPTION_IS_TOO_LONG).optional(),
  latitude: yup.number().optional(),
  longitude: yup.number().optional(),
  hours: yup
    .number()
    .typeError(ERRORS.RESERVATION_LIMIT_IS_INVALID)
    .max(48, ERRORS.RESERVATION_LIMIT_MAX_MIN)
    .min(2, ERRORS.RESERVATION_LIMIT_MAX_MIN)
    .required(ERRORS.RESERVATION_LIMIT_IS_REQUIRED),
});
